import type { InvitationCapabilitiesV3Response } from '../types';

const JSW = 'jira-software';

export const canUserInvite = async (cloudId: string, product = JSW) => {
	const capabilities = await fetch(
		`/gateway/api/v3/invitations/capabilities?resource=ari:cloud:platform::site/${cloudId}`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
	const capability = (
		(await capabilities.json()) as unknown as InvitationCapabilitiesV3Response[]
	).find((cap) => {
		const resourceOwner = cap.resourceARI.split(':')[2];
		return resourceOwner === product;
	});

	if (!capability) {
		return false;
	}

	return (
		capability.directInvite?.mode === 'ANYONE' ||
		capability.invitePendingApproval?.mode === 'ANYONE'
	);
};
